import { useEffect } from 'react';

import InputGroupView from './InputGroupView';

interface IProps {
  name: string;
  filter: Record<string, any>;
  fields: Record<string, any>;
  values?;
  onChange;
}

const InputGroup = ({ name, filter, fields, values, onChange }: IProps) => {
  const onChangeOption = (name, option) => {
    onChange({
      ...values,
      [name]: option,
    });
  };

  const onClear = () => {
    if (!filter?.individualFields) {
      onChange({
        ...values,
        [name]: null,
      });

      return;
    }

    let newValues = { ...values };
    fields.forEach((field) => {
      newValues = {
        ...newValues,
        [field.name]: null,
      };
    });

    onChange(newValues);
  };

  useEffect(() => {
    if (!values) {
      onChange(null);
    }
  }, [values]);

  return (
    <InputGroupView
      fields={fields}
      values={values}
      onChange={onChangeOption}
      onClear={onClear}
      individualFields={filter?.individualFields}
    />
  );
};

export default InputGroup;
